// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"279":"51f45779","533":"beadf38c"}[chunkId] + ".chunk.css";
};